export const ATTRIBUTE_LABELS = {
  // Vehicle
  vehicle_type: 'Vehicle Type',
  caravan_type: 'Caravan Type',
  price_type: 'Price Type',
  brand: 'Brand',
  model: 'Model',
  year: 'Year',
  fuel_type: 'Fuel Type',
  transmission: 'Transmission',
  mileage: 'Mileage',
  engine_cc: 'Engine Size',
  color: 'Colour',
  body_type: 'Body Type',
  condition: 'Condition',
  has_damage_record: 'Damage Record',
  damage_records: 'Damage Records',
  from_owner: 'From Private Seller',
  warranty: 'Warranty',
  karavan_uzunluk: 'Length (m)',
  karavan_agirlik: 'Weight (kg)',
  karavan_yatak_kapasitesi: 'Bed Capacity',
  karavan_durum: 'Condition',
  karavan_mutfak: 'Kitchen',
  karavan_banyo: 'Bathroom/WC',
  karavan_klima: 'Air Conditioning',
  karavan_isitma: 'Heating System',
  karavan_solar: 'Solar Panel',
  karavan_su_deposu: 'Water Tank (L)',
  karavan_jenerator: 'Generator',
  karavan_tente: 'Awning/Pergola',
  // Property — Basics
  property_type: 'Property Type',
  listing_type: 'Listing Type',
  owner_type: 'Listing Owner',
  room_count: 'Number of Rooms',
  gross_area: 'Gross m²',
  net_area: 'Net m²',
  floor: 'Floor',
  total_floors: 'Total Floors',
  building_age: 'Building Age',
  bathroom_count: 'Number of Bathrooms',
  wc_count: 'WC Count',
  balcony_count: 'Number of Balconies',
  heating_type: 'Heating',
  rent_period: 'Rent Period',
  deposit: 'Deposit',
  commission: 'Commission',
  energy_class: 'Energy Class',
  // Property — Transport & Location
  near_metro: 'Near Underground Station',
  near_bus_stop: 'Near Bus Stop',
  on_main_road: 'On Main Road',
  near_school: 'Near School',
  near_hospital: 'Near Hospital',
  near_market: 'Near Supermarket',
  near_park: 'Near Park',
  metro_distance: 'Distance to Underground',
  bus_distance: 'Distance to Bus Stop',
  main_road: 'Distance to Main Road',
  school_distance: 'Distance to School',
  hospital_distance: 'Distance to Hospital',
  market_distance: 'Distance to Supermarket',
  park_distance: 'Distance to Park',
  view: 'View',
  location_type: 'Location Type',
  // Estate / Compound
  site_pool: 'Estate Swimming Pool',
  site_gym: 'Gym',
  site_sauna: 'Sauna',
  site_security: 'Estate Security',
  site_camera: 'Security Camera',
  site_playground: 'Children\'s Playground',
  site_garden: 'Estate Garden',
  site_parking: 'Indoor Parking',
  site_open_parking: 'Outdoor Parking',
  site_generator: 'Generator',
  site_doorman: 'Concierge',
  site_meeting_room: 'Meeting Room',
  site_tennis: 'Tennis Court',
  site_basketball: 'Basketball Court',
  // Inside the flat
  furnished: 'Furnished',
  air_conditioning: 'Air Conditioning',
  builtin_kitchen: 'Built-in Kitchen',
  white_goods: 'White Goods',
  fiber_internet: 'Fibre Internet',
  satellite: 'Satellite',
  steel_door: 'Steel Door',
  alarm: 'Alarm System',
  intercom: 'Video Intercom',
  jacuzzi: 'Jacuzzi',
  fireplace: 'Fireplace',
  laundry_room: 'Utility Room',
  dressing_room: 'Dressing Room',
  parent_bathroom: 'En-suite Bathroom',
  terrace: 'Terrace',
  cellar: 'Cellar',
  // Outside
  elevator: 'Lift',
  private_garden: 'Private Garden',
  private_pool: 'Private Pool',
  garage: 'Garage',
  disabled_access: 'Disabled Access',
  fire_escape: 'Fire Escape',
  fire_exit: 'Fire Exit',
  // Other
  deed_status: 'Title Deed Status',
  usage_status: 'Usage Status',
  credit_eligible: 'Mortgage Eligible',
  swap_eligible: 'Open to Swap',
  // Land & Plot
  parcel_area: 'Plot Area (m²)',
  zoning_status: 'Zoning Status',
  gabari: 'Building Height Limit',
  emsal: 'Floor Area Ratio (FAR)',
  taks: 'Site Coverage Ratio',
  ada_parsel: 'Block/Plot No',
  infra_water: 'Water',
  infra_electric: 'Electricity',
  infra_gas: 'Gas',
  infra_road: 'Road Frontage',
  // Commercial
  commercial_area: 'Commercial Area (m²)',
  ceiling_height: 'Ceiling Height',
  has_tenant: 'Tenanted',
  monthly_rent_income: 'Monthly Rental Income',
  // Plant & Machinery
  machine_type: 'Machine Type',
  capacity: 'Capacity',
  working_hours: 'Operating Hours',
  rental_type: 'Rental Type',
  operator_included: 'Operator Included',
  transport_included: 'Transport Included',
  fuel_included: 'Fuel Included',
  // Job Listings
  job_type: 'Working Pattern',
  sector: 'Sector',
  position: 'Position',
  experience: 'Experience',
  education: 'Education',
  salary_type: 'Pay Type',
  salary_min: 'Minimum Salary',
  salary_max: 'Maximum Salary',
  salary_range: 'Salary Range',
  gender: 'Gender',
  age_min: 'Minimum Age',
  age_max: 'Maximum Age',
  military_status: 'Military Status',
  driver_license: 'Driving Licence',
  accommodation: 'Accommodation',
  food: 'Meals',
  transport: 'Transport',
  insurance: 'Insurance',
  // Vehicle Rental
  min_driver_age: 'Minimum Driver Age',
  min_license_years: 'Minimum Licence Years',
  deposit_required: 'Deposit Required',
  km_limit: 'Mileage Limit',
  insurance_included: 'Insurance Included',
  delivery_available: 'Delivery Available',
  // Events
  event_type: 'Event Type',
  event_date: 'Event Date',
  end_date: 'End Date',
  venue: 'Venue',
  has_ticket: 'Ticketed Event',
  ticket_price: 'Ticket Price',
  organizer_name: 'Organiser',
  organizer_phone: 'Organiser Phone',
  organizer_email: 'Organiser Email',
  age_restriction: 'Age Limit',
  dress_code: 'Dress Code',
  service_type: 'Service Type',
  date_start: 'Start Date',
  date_end: 'End Date',
  indoor_outdoor: 'Venue Type',
  parking: 'Parking',
  catering_available: 'Catering Available',
  sound_system: 'Sound System',
  // Marketplace
  product_category: 'Product Category',
  delivery: 'Delivery',
  returnable: 'Returnable',
  // Services
  service_category: 'Service Category',
  service_location: 'Service Location',
  availability: 'Availability',
  experience_years: 'Experience (Years)',
  team_size: 'Team Size',
  certified: 'Certified',
  insured: 'Insured',
  guarantee: 'Work Guarantee',
  free_inspection: 'Free Inspection',
  // Commercial Property
  vitrin: 'Shopfront',
  vitrin_length: 'Shopfront Length',
  asma_kat: 'Mezzanine',
  wc_inside: 'Has WC inside',
  loading_ramp: 'Loading Ramp',
  electric_capacity: 'Electric Capacity',
  rental_income: 'Monthly Rental Income',
  tenant_exists: 'Tenanted',
  suitable_for: 'Suitable Sectors',
  // Land/Plot
  land_area: 'Plot Area',
  floor_rights: 'Floor Permission',
  parcel_no: 'Block/Plot',
  road_access: 'Road Frontage',
  road_width: 'Road Width',
  water_available: 'Water Available',
  electric_available: 'Electricity Available',
  natural_gas_available: 'Gas Available',
  tree_count: 'Number of Trees',
  irrigation: 'Irrigation System',
  // Farm
  has_well: 'Water Well',
  has_barn: 'Barn/Hay Loft',
  has_greenhouse: 'Greenhouse',
  storage_building: 'Storage Building',
};

export function formatAttributeValue(key, value) {
  if (typeof value === 'boolean') return 'Yes';
  if (key === 'mileage') return `${new Intl.NumberFormat('en-GB').format(value)} mi`;
  if (['deposit', 'commission', 'salary_min', 'salary_max', 'rental_income'].includes(key)) {
    return `£${new Intl.NumberFormat('en-GB').format(value)}`;
  }
  if (['gross_area', 'net_area', 'land_area'].includes(key)) {
    return `${new Intl.NumberFormat('en-GB').format(value)} m²`;
  }
  if (['vitrin_length', 'ceiling_height', 'road_width'].includes(key)) return `${value} m`;
  if (key === 'damage_records' && Array.isArray(value)) return null;
  if (Array.isArray(value)) return value.join(', ');
  return value;
}

export const HIDDEN_ATTRIBUTE_KEYS = ['aracplaka', 'plaka', 'tasinmazno', 'tasinmaz_no'];

export function shouldShowAttribute(key, value, listingType) {
  if (value === null || value === undefined || value === '') return false;
  if (typeof value === 'boolean' && value === false) return false;
  if (Array.isArray(value) && value.length === 0) return false;
  if (key === 'damage_records' && Array.isArray(value) && value.length === 0) return false;
  if (key === 'rent_period' && listingType === 'For Sale') return false;
  if (key === 'deposit' && listingType === 'For Sale') return false;
  if (HIDDEN_ATTRIBUTE_KEYS.includes(key)) return false;
  // Hide form draft "_display" companion fields — only used for UI formatting.
  if (typeof key === 'string' && key.endsWith('_display')) return false;
  // Salary min/max are shown in the main price block; hide from attributes table.
  if (key === 'salary_min' || key === 'salary_max') return false;
  return true;
}
